import { useRouter } from "@tanstack/react-router";
import { useCallback } from "react";
import type { DataTableRowActivation } from "@rootline/ui/components/tables";

type NavigateOptions = Parameters<ReturnType<typeof useRouter>["navigate"]>[0];

declare module "@tanstack/history" {
  interface HistoryState {
    fromPaymentDetails?: boolean;
    fromTransactionsList?: boolean;
    fromSignals?: boolean;
    fromDisputesList?: boolean;
  }
}

export function useRowNavigation() {
  const router = useRouter();

  return useCallback(
    (options: NavigateOptions, activation: DataTableRowActivation) => {
      if (activation.openInNewTab) {
        const location = router.buildLocation(options);
        window.open(location.href, "_blank", "noopener,noreferrer");
        return;
      }

      void router.navigate(options);
    },
    [router],
  );
}
